import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PickedAndPackedResponse } from 'src/app/wings-mobile/models/picked-and-packed/picked-and-packed-response.model';
import { PickingSaveRequest } from 'src/app/wings-mobile/models/picked-and-packed/picking-save-request.model';
import { environment } from "src/environments/environment";

@Injectable({
	providedIn: 'root'
})
export class PickingService {

	private httpOptions = { headers: new HttpHeaders({ 'Content-type': 'application/json' }) };
	private subRoute = "pickedAndPacked";

	constructor(private http: HttpClient) {
		this.http = http;
	}

	getPicking(labelCode: string, subdivision: number) {
		const URL = environment.backend_Jab_url + this.subRoute + `/${labelCode}/subdivision/${subdivision}`
		return this.http.get<Array<PickedAndPackedResponse>>(URL);
	}

	savePicking(pickingSave: PickingSaveRequest) {
		const URL = environment.backend_Jab_url + this.subRoute + "/updateMobile";
		return this.http.put<PickedAndPackedResponse>(URL, pickingSave);
	}

	checkSerialNumber(serialNumber) {
		const URL = environment.backend_Jab_url + this.subRoute + "/verify";
		return this.http.post<any>(URL, { "serialNumber": serialNumber })
	}

	// binToBulk(binBulkBinRequest: PickingSaveRequest) {
	// 	const URL = environment.backend_Jab_url + this.subRoute + "/binToBulk";
	// 	return this.http.post<PickedAndPackedResponse>(URL, binBulkBinRequest);
	// }
	//
	// bulkToBin(binBulkBinRequest: PickingSaveRequest) {
	// 	const URL = environment.backend_Jab_url + this.subRoute + "/bulkToBin";
	// 	return this.http.post<PickedAndPackedResponse>(URL, binBulkBinRequest);
	// }
}
